import { api } from '@/api'

export interface Category {
  id: string
  name: string
}

export interface Question {
  id: string
  question: string
  answer: string
  category?: Category
}

export interface QuestionPayload {
  question: string
  answer: string
  categoryId?: string | null
}

export const questionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createQuestion: builder.mutation<{ id: string }, QuestionPayload>({
      query: (body) => ({
        url: '/cmd/question/create-question',
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['Question'],
    }),

    updateQuestion: builder.mutation<void, { id: string } & Partial<QuestionPayload>>({
      query: ({ id, ...body }) => ({
        url: `/cmd/question/${id}/update-question`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: ['Question'],
    }),

    deleteQuestion: builder.mutation<void, string>({
      query: (id) => ({
        url: `/cmd/question/${id}/delete-question`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Question'],
    }),

    getQuestions: builder.query<Question[], void>({
      query: () => ({
        url: '/query/question/get-all',
        method: 'GET',
      }),
      providesTags: ['Question'],
    }),

    getCategories: builder.query<Category[], void>({
      query: () => ({
        url: '/query/category/get-all-categories',
        method: 'GET',
      }),
      providesTags: ['Category'],
    }),
  }),
  overrideExisting: false,
})

export const {
  useCreateQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
  useGetQuestionsQuery,
  useGetCategoriesQuery,
} = questionApi
